import React from 'react';
import { ChefHat, Users, CircleCheck, SkipForward, RotateCcw } from 'lucide-react';
import { Badge } from '../ui/badge';

const MemberPrepItemRow = ({ item, prep, isMine, onTaskAction, onUndoTask }) => {
  const assigneeNames = (prep.assigned_to_names || []).join(', ');
  const isDone = prep.status === 'done';
  const dailyId = prep.id || null;

  return (
    <div
      className={`px-3 md:px-5 py-3 ${isMine ? (isDone ? 'bg-emerald-500/5' : 'bg-neon-pink/5') : ''}`}
      data-testid={`prep-item-row-${item.id}`}
    >
      <div className="flex flex-wrap items-center gap-2 md:gap-3">
        {/* Item name */}
        <div className="flex-1 min-w-[120px]">
          <span className={`font-medium text-sm block truncate ${isDone && isMine ? 'text-gray-400 line-through' : 'text-gray-900'}`}>
            {isMine && <ChefHat size={12} className="inline mr-1 text-neon-pink" />}
            {item.name}
          </span>
        </div>

        {/* Assignee names (read-only) */}
        {assigneeNames && (
          <span className="text-[10px] px-2 py-0.5 rounded bg-gray-100 border border-gray-200 text-gray-500 truncate max-w-[120px] flex-shrink-0">
            <Users size={9} className="inline mr-1" />{assigneeNames}
          </span>
        )}

        {/* Quantity + Unit (read-only) */}
        {prep.quantity > 0 && (
          <span className="text-xs text-gray-500 flex-shrink-0">{prep.quantity} {prep.unit}</span>
        )}

        {/* Note (read-only) */}
        {prep.note && (
          <span className="text-xs text-gray-400 italic truncate max-w-[100px] flex-shrink-0">{prep.note}</span>
        )}

        {/* Action buttons - only for MY tasks */}
        {isMine && dailyId && (
          isDone ? (
            <div className="flex items-center gap-1.5 flex-shrink-0">
              <Badge className="bg-emerald-500/10 text-emerald-600 border border-emerald-500/30 text-[10px]">Fait</Badge>
              <button
                onClick={() => onUndoTask(dailyId)}
                className="w-7 h-7 rounded-lg bg-gray-100 border border-gray-200 text-gray-500 hover:text-gray-900 flex items-center justify-center transition-colors"
                data-testid={`undo-btn-${dailyId}`}
              >
                <RotateCcw size={12} />
              </button>
            </div>
          ) : (
            <div className="flex items-center gap-1.5 flex-shrink-0">
              <button
                onClick={() => onTaskAction(dailyId, 'done')}
                className="w-9 h-9 rounded-xl bg-emerald-500/10 border border-emerald-500/30 text-emerald-600 hover:bg-emerald-500/20 flex items-center justify-center transition-colors"
                data-testid={`done-btn-${dailyId}`}
              >
                <CircleCheck size={18} />
              </button>
              <button
                onClick={() => onTaskAction(dailyId, 'skipped')}
                className="w-9 h-9 rounded-xl bg-orange-500/10 border border-orange-500/30 text-orange-600 hover:bg-orange-500/20 flex items-center justify-center transition-colors"
                data-testid={`skip-btn-${dailyId}`}
              >
                <SkipForward size={18} />
              </button>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default MemberPrepItemRow;
